export default __webpack_public_path__ + "static/sabun-42f960f64ec5f45ef3ef6e14da6093ab.mp4";